export default __webpack_public_path__ + "static/media/reset_time.ed17e4f8.svg";